import { remapAttachmentRequestSections } from './attachmentService';
import { buildRepeatableInstanceAttachmentSectionRemapsForIdMap } from '../utils/repeatableInstanceAttachmentSections';

/** Persist scoped attachment section keys when draft child ids are saved (#1154 Bug 5). */
export async function flushRepeatableInstanceAttachmentSectionRemaps(
  requestId: string,
  idMap: ReadonlyMap<number, number>,
  baseSectionIds: readonly string[],
  useOnlineApi: boolean,
): Promise<void> {
  if (!useOnlineApi || idMap.size === 0) {
    return;
  }

  const remaps = buildRepeatableInstanceAttachmentSectionRemapsForIdMap(
    idMap,
    baseSectionIds,
  );
  if (remaps.length === 0) {
    return;
  }

  const numericRequestId = Number.parseInt(requestId, 10);
  if (!Number.isFinite(numericRequestId)) {
    return;
  }

  await remapAttachmentRequestSections(numericRequestId, remaps);
}
